
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.4 6.6H8.2a1.6 1.6 0 00-1.6 1.6v7.2A1.6 1.6 0 008.2 17h7.2a1.6 1.6 0 001.6-1.6V8.2a1.6 1.6 0 00-1.6-1.6z","stroke":"#000C1F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.4 11.4h-.8A1.6 1.6 0 011 9.8V2.6A1.6 1.6 0 012.6 1h7.2a1.6 1.6 0 011.6 1.6v.8","stroke":"#000C1F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    